import PropTypes from 'prop-types';
import React from 'react';
import StyleSheet from 'utilities/StyleSheet';
import HorizontalCard from './HorizontalCard';
import * as Colors from 'constants/Colors';

class HorizontalCardIcon extends React.Component {
  getStyleSheet() {
    return StyleSheet({
      container: {
        border: `1px solid ${Colors.COLOR__BLACK_10}`,
        width: 96,
        height: 56,
        display: 'flex',
      },

      children: {
        margin: 'auto',
      },
    });
  }

  render() {
    const stylesheet = this.getStyleSheet();
    const visualization = (
      <div style={stylesheet.container}>
        <div style={stylesheet.children}>{this.props.icon}</div>
      </div>
    );

    return (
      <HorizontalCard visualization={visualization}>
        {this.props.children}
      </HorizontalCard>
    );
  }
}

HorizontalCardIcon.propTypes = {
  icon: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default HorizontalCardIcon;
